import { createContext, useContext, useEffect, useState, type ReactNode } from "react";
import { CommandMenu } from "./command-menu";

type SearchContextType = { open: boolean; setOpen: React.Dispatch<React.SetStateAction<boolean>> };

const SearchContext = createContext<SearchContextType | null>(null);

export function SearchProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const down = (e: KeyboardEvent) => {
      if (e.key === "k" && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setOpen((v) => !v);
      }
    };
    document.addEventListener("keydown", down);
    return () => document.removeEventListener("keydown", down);
  }, []);

  return (
    <SearchContext value={{ open, setOpen }}>
      {children}
      <CommandMenu />
    </SearchContext>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useSearchMenu() {
  const ctx = useContext(SearchContext);
  if (!ctx) throw new Error("useSearchMenu must be used within SearchProvider");
  return ctx;
}
